import { customSpringAxios } from "./axios";

export const getActivePromoBannersApi = async () => {
    const response = await customSpringAxios.get("/promo-banners/active");
    return Array.isArray(response.data) ? response.data : [];
};
